module.exports = __webpack_public_path__ + "img/female-verification@2x.39dda8cf.png";